import React from 'react';

export type Props = {
  className?: string;
  color?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};

export const Success = React.memo((props: Props) => {
  return (
    <svg
      width={props.width || 20}
      height={props.height || 14}
      className={props.className}
      onClick={props.onClick}
      viewBox='0 0 20 14'
    >
      <g fill='none'>
        <path
          d='M17.5563 1.82767L7.65685 11.7272L2 6.07031'
          stroke={props.color || '#4D3386'}
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  );
});

Success.displayName = 'Success';
